import React from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Style from "../../styles/js/Styles";

export default function ScheduleItem({ title, day, handleSchedule }) {
  const localChange = (event, range) => {
    event.preventDefault();
    const indexDay = day[0].day;
    const { name, value } = event.target;
    handleSchedule({ indexDay, range, name, value });
  };

  const getStartTime = (indexRange) => {
    let out = "";
    day.forEach((item, i) => {
      if (i === indexRange) {
        out = item.startTime;
      }
    });
    return out;
  };

  const getEndTime = (indexRange) => {
    let out = "";
    day.forEach((item, i) => {
      if (i === indexRange) {
        out = item.endTime;
      }
    });
    return out;
  };

  const style = Style();
  return (
    <div className={style.scheduleItem}>
      <Paper>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontWeight: "bold",
          }}
        >
          {" "}
          {title}{" "}
        </div>
        <div style={{ fontSize: 10 }}> Rango 1 </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <TextField
            name="startTime"
            value={getStartTime(0)}
            onChange={(event) => localChange(event, 0)}
            style={{ width: "40%", margin: 5 }}
          />
          <TextField
            name="endTime"
            value={getEndTime(0)}
            onChange={(event) => localChange(event, 0)}
            style={{ width: "40%", margin: 5 }}
          />
        </div>
        <div style={{ fontSize: 10 }}> Rango 2 </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <TextField
            name="startTime"
            value={getStartTime(1)}
            onChange={(event) => localChange(event, 1)}
            style={{ width: "40%", margin: 5 }}
          />
          <TextField
            name="endTime"
            value={getEndTime(1)}
            onChange={(event) => localChange(event, 1)}
            style={{ width: "40%", margin: 5 }}
          />
        </div>
      </Paper>
    </div>
  );
}
